// extracted by mini-css-extract-plugin
export default {"skeletonItem":"skeleton_skeletonItem__BAFDO","pulse":"skeleton_pulse__zLgyz"};